var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('input', _vm._g(_vm._b({
    class: (_class = {}, _class[_vm.$style.input] = true, _class[_vm.$style.error] = _vm.error, _class),
    style: {
      background: _vm.changed ? _vm.changedColor : '#fff'
    },
    attrs: {
      "autocomplete": "off",
      "type": _vm.typeChanged
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update', $event.target.value);
      },
      "focus": _vm.handleType,
      "blur": _vm.handleType
    }
  }, 'input', _vm.$attrs, false), _vm.$listeners)), !_vm.hideEye ? _c('span', {
    on: {
      "click": _vm.togglePassword
    }
  }, [_c('BaseIcon', {
    class: _vm.$style.iconInput,
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e(), _c('div', {
    class: _vm.$style.errorContainer
  }, [_vm.error ? _c('p', {
    staticClass: "tag-text",
    class: _vm.$style.errorMessage
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }